// src/components/PageSkeletonLoader.js
import React from 'react';

const PageSkeletonLoader = () => {
    return (
        <div className="animate-pulse" style={{ width: "90%" }}> {/* Hero section skeleton */} <div className="w-full h-64 bg-gray-200 mb-8"></div>
    
            {/* Content sections skeletons */}
            <div className="mx-auto px-4">
            {/* About section skeleton */}
            <div className="bg-gray-100 rounded-lg p-6 mb-8">
                <div className="h-8 bg-gray-200 rounded w-1/3 mb-6 mx-auto"></div>
                <div className="grid md:grid-cols-2 gap-6">
                <div>
                    <div className="h-4 bg-gray-200 rounded mb-3 w-full"></div>
                    <div className="h-4 bg-gray-200 rounded mb-3 w-full"></div>
                    <div className="h-4 bg-gray-200 rounded mb-3 w-5/6"></div>
                    <div className="h-4 bg-gray-200 rounded mb-3 w-4/5"></div>
                </div>
                <div>
                    <div className="h-4 bg-gray-200 rounded mb-3 w-full"></div>
                    <div className="h-4 bg-gray-200 rounded mb-3 w-full"></div>
                    <div className="h-4 bg-gray-200 rounded mb-3 w-3/4"></div>
                    <div className="h-4 bg-gray-200 rounded mb-3 w-5/6"></div>
                </div>
                </div>
            </div>
            
            {/* Features section skeleton */}
            <div className="bg-gray-100 rounded-lg p-6 mb-8">
                <div className="h-8 bg-gray-200 rounded w-1/3 mb-6 mx-auto"></div>
                <div className="grid md:grid-cols-3 gap-6">
                {[1, 2, 3].map(i => (
                    <div key={i} className="bg-white p-4 rounded">
                    <div className="w-16 h-16 bg-gray-200 rounded-full mx-auto mb-4"></div>
                    <div className="h-6 bg-gray-200 rounded w-1/2 mx-auto mb-3"></div>
                    <div className="h-4 bg-gray-200 rounded mb-2 w-full"></div>
                    <div className="h-4 bg-gray-200 rounded mb-2 w-full"></div>
                    <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                    </div>
                ))}
                </div>
            </div>
            
            {/* Mission section skeleton */}
            <div className="bg-gray-200 rounded-lg p-6 mb-8">
                <div className="h-8 bg-gray-300 rounded w-1/4 mb-6 mx-auto"></div>
                <div className="h-4 bg-gray-300 rounded mb-3 w-full mx-auto max-w-2xl"></div>
                <div className="h-4 bg-gray-300 rounded mb-3 w-full mx-auto max-w-2xl"></div>
                <div className="h-4 bg-gray-300 rounded mb-6 w-3/4 mx-auto max-w-2xl"></div>
                <div className="h-10 bg-gray-300 rounded w-36 mx-auto"></div>
            </div>
        </div>
    </div>
    )
};

export default PageSkeletonLoader;